import React, {useContext} from "react";
import {useDispatch} from "react-redux";
import {DutyManagerReportEditableContext} from "../../Context/DutyManagerReportEditable";
import FormHeader from "../../../../../../Form/FormHeader";
import FormRow from "../../../../../../Form/FormRow";
import {DebounceInput} from "react-debounce-input";
import {EndOfShiftReportPayload} from "../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActionTypes";
import {setPayload} from "../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActions";

const EndOfShiftFormDetails = (props: EndOfShiftReportPayload) => {
    const editable = useContext(DutyManagerReportEditableContext);
    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <div className="eos-section">
                <FormHeader headerName={"Operational Report"} />
                <FormRow
                    rowName={"Staffing Issues"}
                    columnDetailClassName={editable ? "pl-0 pr-0" : ""}
                >
                    {editable ? (
                        <DebounceInput
                            className="input-fields text-area-inputs minimum"
                            element={"textarea"}
                            value={props.staffingIssues}
                            onChange={(event) => {
                                const {value} = event.target;
                                const payload: EndOfShiftReportPayload = {
                                    ...props,
                                    staffingIssues: value
                                };

                                dispatch(setPayload(payload));
                            }}
                        />
                    ) : (
                        <p className="mb-0 text-area-inputs">{props.staffingIssues}</p>
                    )}
                </FormRow>
                <FormRow
                    rowName={"Equipment and Consumables Used"}
                    columnDetailClassName={editable ? "pl-0 pr-0" : ""}
                >
                    {editable ? (
                        <DebounceInput
                            className="input-fields text-area-inputs minimum"
                            element={"textarea"}
                            value={props.equipmentAndConsumables}
                            onChange={(event) => {
                                const {value} = event.target;
                                const payload: EndOfShiftReportPayload = {
                                    ...props,
                                    equipmentAndConsumables: value
                                };

                                dispatch(setPayload(payload));
                            }}
                        />
                    ) : (
                        <p className="mb-0 text-area-inputs">{props.equipmentAndConsumables}</p>
                    )}
                </FormRow>
                <FormRow
                    rowName={"Discussion with venue manager (if applicable)"}
                    columnDetailClassName={editable ? "pl-0 pr-0" : ""}
                >
                    {editable ? (
                        <DebounceInput
                            className="input-fields text-area-inputs minimum"
                            element={"textarea"}
                            value={props.discussionWithVenueManager}
                            onChange={(event) => {
                                const {value} = event.target;
                                const payload: EndOfShiftReportPayload = {
                                    ...props,
                                    discussionWithVenueManager: value
                                };

                                dispatch(setPayload(payload));
                            }}
                        />
                    ) : (
                        <p className="mb-0 text-area-inputs">{props.discussionWithVenueManager}</p>
                    )}
                </FormRow>
                <FormRow rowName={"Feedback"} columnDetailClassName={editable ? "pl-0 pr-0" : ""}>
                    {editable ? (
                        <DebounceInput
                            className="input-fields text-area-inputs minimum"
                            element={"textarea"}
                            value={props.feedback}
                            onChange={(event) => {
                                const {value} = event.target;
                                const payload: EndOfShiftReportPayload = {
                                    ...props,
                                    feedback: value
                                };

                                dispatch(setPayload(payload));
                            }}
                        />
                    ) : (
                        <p className="mb-0 text-area-inputs">{props.feedback}</p>
                    )}
                </FormRow>
            </div>
        </React.Fragment>
    );
};

export default EndOfShiftFormDetails;
